import { Bar, mixins } from "vue-chartjs"
import numeral from "numeral"

export default Bar.extend({
    mixins: [mixins.reactiveProp],
    props: {
        chartData: {
            type: Array | Object,
            required: false
        },
        legendPosition: {
            type: String,
            default: "right"
        }
    },
    computed: {
        options () {
            const chart_data = this.chartData
            return {
                tooltips: {
                    mode: "index",
                    callbacks: {
                        title: (tooltipItems, data) => {
                            return chart_data.labels[tooltipItems[0].index]
                        },
                        label: function (tooltipItem, data) {
                            const lines = []

                            data.datasets.forEach((dataset, index) => {
                                let label = (data.dataset_id === "fee") ? "By fee: " : "By projects: "
                                if(dataset._total) {
                                    const percent = numeral((dataset.data[tooltipItem.index] / dataset._total) * 100).format("0,0")
                                    const prefix = (data.dataset_id === "fee") ? "$ " : ""
                                    label = `${label} ${prefix}${numeral(dataset.data[tooltipItem.index]).format("0,0")} (${percent}%)`
                                }
                                lines.push(label)
                            })
                            return lines
                        }
                    }
                },
                scales: {
                    yAxes: [{
                        stacked: true,
                        ticks: {
                            beginAtZero: true,
                            fontColor: "#00274F",
                            callback: function (value, index, values) {
                                const prefix = (chart_data.dataset_id === "fee") ? "$ " : ""
                                return `${prefix}${numeral(value).format("0,0")}`
                            }
                        },
                        gridLines: {
                            display: true,
                            color: "rgba(0, 39, 79, 0.1)"
                        }
                    }],
                    xAxes: [{
                        stacked: true,
                        ticks: {
                            display: true,
                            fontColor: "#00274F",
                            callback: function (value) {
                                const MAX_LENGTH = 20
                                if(value.length <= MAX_LENGTH) return value
                                return value.substr(0, (MAX_LENGTH - 3)) + "..."
                            }
                        },
                        gridLines: {
                            display: false
                        },
                        categoryPercentage: 0.9,
                        barPercentage: 0.8
                    }]
                },
                legend: {
                    display: false
                },
                responsive: true,
                maintainAspectRatio: false
            }
        }
    },
    mounted () {
        this.renderChart(this.chartData, this.options)
    }
})
